import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RequestUpdateUserName } from '../models/requestUpdateUserName';

@Injectable({
  providedIn: 'root'
})
export class SubMenuService {
  urlService = `${environment.urlglobal_api}/api/v3/checkout/UpdateUserNameInOrder`;
  
  constructor(
    private readonly http: HttpClient,
  ) { }

  updateUserNameInOrder = (token: string, requestBody: RequestUpdateUserName): Observable<any> => {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    }
    return this.http.post<RequestUpdateUserName>(this.urlService, requestBody, headers).pipe(map((res) => res));
  }
}
